function isEmpty(value) {
  return value == null || (typeof value === "string" && value.trim() === "");
}

function parseJsonValue(value, fieldName) {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch (error) {
    const validationError = new TypeError(`${fieldName} 不是有效的 JSON`);
    validationError.isJsonFieldValidationError = true;
    throw validationError;
  }
}

function validateJsonValue(value, fieldName, type) {
  const valid = type === "array"
    ? Array.isArray(value)
    : value && typeof value === "object" && !Array.isArray(value);
  if (!valid) {
    const typeLabel = type === "array" ? "数组" : "对象";
    const error = new TypeError(`${fieldName} 必须是${typeLabel}`);
    error.isJsonFieldValidationError = true;
    throw error;
  }
}

/**
 * 兼容旧 Node 接口：指定字段必须以 JSON 字符串传入，而不是 qs 的嵌套参数。
 * schema: { fieldName: "array" | "object" | { type, optional, omitEmptyArray } }
 */
export function normalizeLegacyJsonFields(data, schema) {
  const payload = { ...(data || {}) };
  Object.keys(schema).forEach(fieldName => {
    const rawRule = schema[fieldName];
    const rule = typeof rawRule === "string" ? { type: rawRule } : rawRule;
    let value = payload[fieldName];

    if (isEmpty(value)) {
      if (rule.optional) {
        delete payload[fieldName];
        return;
      }
      value = rule.type === "object" ? {} : [];
    } else {
      value = parseJsonValue(value, fieldName);
    }

    if (rule.optional && rule.omitEmptyArray && Array.isArray(value) && value.length === 0) {
      delete payload[fieldName];
      return;
    }
    validateJsonValue(value, fieldName, rule.type);
    payload[fieldName] = JSON.stringify(value);
  });
  return payload;
}
